import { MutationCache, QueryClient } from '@tanstack/react-query';
import { ApiError } from '@/api/client';
import { membershipLink, toastError } from '@/lib/errors';

export function createQueryClient() {
  return new QueryClient({
    // Work refused for a lapsed membership (402) always gets the toast that links to the membership page, also from forms that show
    // their errors inline; it has a fixed id, so a screen that toasts the error itself does not show it twice.
    mutationCache: new MutationCache({
      onError: (error) => {
        if (membershipLink(error)) toastError(error);
      },
    }),
    defaultOptions: {
      queries: {
        staleTime: 15_000,
        refetchOnWindowFocus: true,
        retry: (count, error) => {
          if (error instanceof ApiError && error.status < 500) return false;
          return count < 2;
        },
      },
      mutations: { retry: false },
    },
  });
}
